export function headerSearch() {
  const headerSearch = document.querySelector('.header-search');
  const searchTrigger = document.querySelector('.header-search__trigger');
  const searchActive = document.querySelector('.header');
  const primaryNavItems = document.querySelector('.primary-nav__item');

  searchTrigger.addEventListener('click', () => {
    searchTrigger.classList.toggle('is-active');
    if (!searchActive.classList.contains('is-search-active')) {
      searchActive.classList.add('is-search-active');
      headerSearch.classList.add('is-active');
      primaryNavItems.classList.remove('is-open');
    } else {
      setTimeout(() => {
        searchActive.classList.remove('is-search-active');
        headerSearch.classList.remove('is-active');
      }, 230);
    }
  });
}



// WEBPACK FOOTER //
// ./src/ktu/js/components/Header.js